import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { siteConfig } from "@/config/siteConfig";

export const Pricing = () => (
  <section id="pricing" className="bg-white py-24 sm:py-32" data-testid="pricing-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Pricing</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
          Simple plans, honest prices.
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
          Four monthly plans. No hidden fees, no inflated promises — exact inclusions
          and usage limits are always shown in the ORIVA app before you pay.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {siteConfig.pricing.map((plan, i) => (
          <Reveal key={plan.id} delay={i * 0.07}>
            <article
              className={`flex h-full flex-col rounded-2xl border bg-white p-7 ${
                plan.highlighted
                  ? "border-oriva-blue ring-1 ring-oriva-blue/20"
                  : "border-slate-200"
              }`}
              data-testid={`pricing-card-${plan.id}`}
            >
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">{plan.name}</p>
              <p className="mt-5 font-display text-4xl font-semibold tracking-tight text-slate-900">
                ₹{plan.priceInr.toLocaleString("en-IN")}
                <span className="ml-1 align-middle font-sans text-sm font-normal text-slate-500">/month</span>
              </p>

              <div className="mt-6 flex-1">
                {plan.benefits.length > 0 ? (
                  <ul className="flex flex-col gap-2.5">
                    {plan.benefits.map((benefit) => (
                      <li key={benefit} className="flex items-start gap-2 text-sm text-slate-600">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-oriva-cyan" />
                        {benefit}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm leading-relaxed text-slate-500">
                    Full inclusions and limits for this plan are listed in the ORIVA app
                    before purchase.
                  </p>
                )}
              </div>

              <Link
                to="/#app"
                data-testid={`pricing-cta-${plan.id}`}
                className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition-colors duration-200 ${
                  plan.highlighted
                    ? "bg-oriva-blue text-white hover:bg-blue-700"
                    : "border border-slate-300 text-slate-800 hover:border-slate-400 hover:bg-slate-50"
                }`}
              >
                Get ORIVA
                <ArrowRight className="h-4 w-4" />
              </Link>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 max-w-2xl text-sm leading-relaxed text-slate-500" data-testid="pricing-footnote">
          Prices are in Indian Rupees (INR) and billed monthly through the app store.
          Subscriptions can be managed or cancelled at any time from your store account.
          Applicable taxes may apply.
        </p>
      </Reveal>
    </div>
  </section>
);
